
/* Change this file to get your personal Portfolio */

// Your Summary And Greeting Section

import emoji from "react-easy-emoji";

const greeting = {
  /* Your Summary And Greeting Section */
  username: "Martins Zeltins",
  title: "Sveiki, mani sauc Mārtiņš!",
  subTitle: emoji("Esmu full stack web programmētājs ar vairāku gadu pieredzi backend un frontend programmēšanā. Man patīk tādas tehnoloģijas kā Javascript / PHP / Laravel / Vue / Docker / Nodejs."),
  resumeLink: "#"
};

// Your Social Media Link

const socialMediaLinks = {

  github: "https://github.com/martinszeltins",
  linkedin: "#",
  gmail: "martinszeltins@gmail.com",
  gitlab: "https://gitlab.com/martinszeltins",
  facebook: "#"
};

// Your Skills Section

const skillsSection = {
  title: "Man patīk šādas tehnoloģijas",
  subTitle: "",
  skills: [
    emoji("⚡ Izstrādāju modernu UI / UX tavai aplikācijai vai mājaslapai"),
    emoji("⚡ Progresīvās web aplikācijas (PWA) un Single page aplikācijas (SPA)"),
    emoji("⚡ Integrācija ar citām aplikācijām un pakalpojumiem")
  ],

/* Make Sure You include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design",  //Insert stack or technology you have experience in
      progressPercentage: "90%"  //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: "Your Github Converted Token",
  githubUserName: "Your Github Username",
  showGithubProfile :"false" // Set true or false to show Contact profile using Github, defaults to false 
};


// Some Big Projects You have worked with your company

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: "https://drive.google.com/uc?id=1exWn9T6j8TsfDDHJnS3VR66eP6RiGAfY",
      link: "http://saayahealth.com/"
    },
    {
      image: "https://drive.google.com/uc?id=1MXoXcQRK-pH8J82wyjCW4SJk5AxJe7tf",
      link: "http://nextu.se/"
    }
  ]
};

// Your Achievement Section Include Your Certification Talks and More

const achievementSection = {

  title: emoji("Paveiktie projekti"),
  subtitle: "Šeit vari apskatīt dažus no maniem paveiktajiem darbiem, ar kuriem lepojos!",

  achivementsCards: [
    {
      title: "Kases sistēma restorāniem",
      subtitle: "Klients vērsās ar lūgumu izstrādāt jaunu un mūsdienīgu kases sistēmu kafejnīcām un restorāniem. Jaunā sistēma tika integrēta esošajā uzņēmuma infrastruktūrā, ļaujot uzņēmuma darbiniekiem veiksmīgi un bez aizķeršanās veikt pāreju un optimizēt savu darbu. Izmantotās tehnoloģijas (Node.js, Javascript, Laravel un Vue.js)",
      image:
        "https://www.martinsz.lv/images/portfolio/cash_register_portfolio.jpg",
      footerLink: [
        
      ]
    },
	
    {
      title: "SMS Master",
      subtitle: "Izstrādāju SMS pakalpojumu aplikāciju ērtai un vienkāršai SMS izsūtīšanai, mobilajam marketingam un komunikācijai ar klientiem. Aplikācija nodrošina arī ērtu rēķinu pārskatu un apstrādi, atvieglojot to izsūtīšanu un apmaksu.",
      image:
        "https://www.martinsz.lv/images/portfolio/sms_master_portfolio.jpg",
      footerLink: [
        
      ]
    },

    {
      title: "TV aplikācija",
      subtitle: "TV prezentāciju aplikācija tika izveidota pēc klienta lūguma, lai varētu atspoguļot darbinieku un uzņēmuma statistiku vieglā un pārskatāmā veidā. Aplikācija piedāvā attēlot gan dinamisku uzņēmuma datu atspoguļojumu (integrējot to esošā sistēmā), gan arī statiskus paziņojumus ar automātisku atjaunošanu.",
      image:
        "https://www.martinsz.lv/images/portfolio/tv_app_portfolio.jpg",
      footerLink: [
        
      ]
    },
	
	{
      title: "Atvaļinājumi",
      subtitle: "Tika izstrādāts atvaļinājumu aplikācijas projekts, kurš ietvēra sevī integrāciju esošajā datubāzes sistēmā. Izmantojot šo aplikāciju uzņēmuma darbinieki spēj pieteikt atvaļinājumu elektroniski, par ko tiks informēta administrācija un pārējie kolēģi.",
      image:
        "https://www.martinsz.lv/images/portfolio/vacations_app_portfolio.jpg",
      footerLink: [
        
      ]
    },
  ]
};

// Blogs Section

const blogSection = {

  title: "Blogs",
  subtitle: "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description: "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description: "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ]
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji("I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/",
      image:
        "https://scontent.fkhi6-1.fna.fbcdn.net/v/t1.0-9/76714032_1730516240415559_1293494289556307968_o.jpg?_nc_cat=103&_nc_ohc=s5f81rdZd6wAQmqUa52YQBA21MjVOy7e-HN9jI7MspRDC-v5ahEouyInQ&_nc_ht=scontent.fkhi6-1.fna&oh=c29141a9a0de7ff2011a8191f5475a78&oe=5E83127C"
    }
  ]
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: ["https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"]
};

const contactInfo = {
  title: emoji("Uzraksti man"),
  subtitle: "Vēlies apspriest nākamo lielo projekta ideju?",
  number: "+371 26542973",
  email_address: "martins@martinsz.lv"
};

//Twitter Section

const twitterDetails = {

  userName : "twitter"//Replace "twitter" with your twitter username without @
  
};
export { greeting, socialMediaLinks, skillsSection, techStack, openSource, bigProjects, achievementSection, blogSection, talkSection, podcastSection, contactInfo , twitterDetails};
